import React, { useState } from "react"
import CommonTitle from "components/common/CommonTitle"
import Layout from "components/Layout/Layout"
import ButtonClose from "components/Button/ButtonClose"
import { Box } from "@mui/material"
import LaunchIcon from "@mui/icons-material/Launch"
import Link from "@mui/material/Link"
import { APP_URL } from "Const"
import GoBackButton from "components/Button/GoBackButton"
import styles from "./Estimable.module.scss"

// 見積対象外エラーのフラグ
export interface Props {
  isNotCovered?: boolean
}
/**
 * Step0見積対象車
 * Step1対象外の車種画面
 * @param {boolean} isNotCovered - TrueならStep1対象外の車種画面、FalseならStep0見積対象車を表示
 */
const Estimable = ({ isNotCovered = false }: Props) => {
  const npList = [
    { alt: "np_01", src: "./np_01.png", name: "自家用普通乗用車", number: "（３ナンバー）" },
    { alt: "np_02", src: "./np_02.png", name: "自家用小型乗用車", number: "（５・７ナンバー）" },
    { alt: "np_03", src: "./np_03.png", name: "自家用小型貨物車", number: "（４ナンバー）" },
    { alt: "np_04", src: "./np_04.png", name: "自家用軽四輪乗用車", number: "（５・７ナンバー）" },
    { alt: "np_05", src: "./np_05.png", name: "自家用軽四輪貨物車", number: "（４・６ナンバー）" }
  ]
  const showList = () => {
    const items: any[] = []
    npList.forEach((list) => {
      items.push(
        <li>
          <img alt={list.alt} src={list.src} />
          <span>{list.name}</span>
          <span>{list.number}</span>
        </li>
      )
    })
    return items
  }
  return (
    <Layout>
      <Box className={styles.nonStepBarWrap}>
        {isNotCovered ? (
          <CommonTitle
            titles={["申し訳ございません。", "お客さまのお車の用途車種は、", "本サイトのお見積り対象外です。"]}
            read="お見積り可能なお車は、以下の用途車種となります。"
          />
        ) : (
          <CommonTitle
            titles={["お見積りできるお車について"]}
            read="お見積り可能なお車は、以下の用途車種となります。"
          />
        )}

        <Box className={styles.imageListWrapper}>
          <ul>{showList()}</ul>
        </Box>
        <Box className={styles.listWrapper}>
          <ul>
            <li>改造車・並行輸入車・型式不明車については、お見積りができません。</li>
            <li>
              その他お見積り可能な条件については、
              <b className={styles.externalHelpLink}>
                <Link
                  href="https://www.sompo-direct.co.jp/otona/clause/"
                  underline="always"
                  color="primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  こちら
                </Link>
                <LaunchIcon className={styles.externalLinkIcon} />
              </b>
              をご確認ください。
            </li>
          </ul>
        </Box>
        {isNotCovered ? <GoBackButton top text="トップ画面に戻る" /> : <ButtonClose />}
      </Box>
    </Layout>
  )
}

export default Estimable
